import { useState } from "react";
import {
  Box,
  Grid,
  IconButton,
  TextField,
  Button,
  Typography,
} from "@mui/material";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { toast } from "react-toastify";
import { clientService } from "../../utils/services/clientService";

const PasswordSettings = ({ editPassword, setEditPassword, user }) => {
  const [passwordData, setPasswordData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const isStrongPassword = (password) => {
    const strongPasswordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).*$/;
    return strongPasswordRegex.test(password);
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prev) => ({ ...prev, [name]: value }));
  };

  const toggleShowPassword = (field) => {
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handleSavePassword = async () => {
    const { oldPassword, newPassword, confirmPassword } = passwordData;
    if (!newPassword || !confirmPassword) {
      return toast.error("Please enter new and confirm password");
    }
    if (newPassword !== confirmPassword) {
      return toast.error("Passwords do not match");
    }
    if (!isStrongPassword(confirmPassword)) {
      return toast.error(
        "Password must include uppercase, lowercase, digit, special char"
      );
    }
    try {
      await clientService.updatePassword({
        email: JSON.parse(user).email,
        oldPassword,
        newPassword,
      });
      toast.success("Password updated successfully");
      setPasswordData({
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
      setEditPassword(false);
    } catch (err) {
      toast.error("Failed to update password");
      console.error(err);
    }
  };

  return (
    <Box
      sx={{
        borderRadius: "8px",
        marginTop: "20px",
        padding: "20px",
        backgroundColor: "var(--bg-paper)",
        width: "99%",
        position: "relative",
        borderBottom: "0.5px solid var(--border-color)",
      }}
    >
      <Grid container spacing={2}>
        {!editPassword ? (
          <Grid item container>
            <Grid item xs={5}>
              <Typography
                sx={{
                  textAlign: "start",
                  fontFamily: "poppins",
                  fontWeight: 500,
                }}
              >
                Password
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography
                sx={{
                  color: "var(--text-primary)",
                  fontWeight: "500",
                  fontFamily: "poppins",
                  textAlign: "start",
                }}
              >
                : *********
              </Typography>
            </Grid>
            <Grid item xs={2} sx={{ position: "absolute", right: 1, top: -5 }}>
              <IconButton onClick={() => setEditPassword(true)}>
                <DriveFileRenameOutlineIcon sx={{ color: "primary.main" }} />
              </IconButton>
            </Grid>
          </Grid>
        ) : (
          <>
            {["oldPassword", "newPassword", "confirmPassword"].map((field) => (
              <Grid item container key={field} alignItems="center">
                <Grid item xs={5}>
                  <Typography
                    sx={{
                      textAlign: "start",
                      fontFamily: "poppins",
                      fontWeight: 500,
                    }}
                  >
                    {field
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, (str) => str.toUpperCase())}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    size="small"
                    fullWidth
                    type={showPassword[field] ? "text" : "password"}
                    name={field}
                    value={passwordData[field]}
                    onChange={handlePasswordChange}
                  />
                </Grid>
                <Grid item xs={1}>
                  <IconButton onClick={() => toggleShowPassword(field)}>
                    {showPassword[field] ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </Grid>
              </Grid>
            ))}
          </>
        )}
      </Grid>

      {editPassword && (
        <Box
          sx={{
            margin: 2,
            width: "95%",
            justifyContent: "flex-end",
            display: "flex",
          }}
        >
          <Button
            style={{ marginRight: 15, color: "red", borderColor: "red" }}
            variant="outlined"
            onClick={() => setEditPassword(false)}
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSavePassword}>
            Update
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default PasswordSettings;
